import axios from 'axios';
import { cloneDeep, isArray, isObject, isEmpty } from 'lodash';
import { Message } from 'element-ui';
import store from '../store';

function queryJoin(url, key, value) {
    if (url.indexOf('?') > -1) {
        url += '&';
    } else {
        url += '?';
    }
    url += `${key}=${value}`;
    return url;
}

function paramsToQueryString(url, params) {
    if (!cloneDeep(params)) {
        throw new Error('params must Object!!');
    }
    if (isObject(params) && !isEmpty(params)) {
        for (const key in params) {
            if (isArray(params[key])) {
                // eslint-disable-next-line
                params[key].forEach((val) => {
                    url = queryJoin(url, key, encodeURIComponent(val));
                });
            } else {
                url = queryJoin(url, key, encodeURIComponent(params[key]));
            }
        }
    }
    return url;
}

function replaceQuery(path, options) {
    // 动态匹配参数替换
    let url = path
        .replace(/:(.*?)(\/|\?| )/g, (a, b, c) => {
            const value = options.params[b];
            delete options.params[b];
            return `${value}${c}`;
        })
        .trim();
    if (options.method === 'GET') {
        if (options.params) {
            url = paramsToQueryString(url, options.params);
        }
    }
    return url;
}

axios.interceptors.request.use(
    config => {
        if (!config.url.includes('TobDesign/api')) {
            config.url = `TobDesign/api${config.url}`;
        }
        return config;
    },
    error => {
        throw new Error(error);
    }
);

axios.interceptors.response.use(
    async response => {
        const { code } = response.data;
        if (code !== 0) {
            if (code === 7) {
                await store.dispatch('user/LogOut');
                Message.error('登录失效，请重新登录');
            } else {
                Message.error(response.data.msg);
            }
            return Promise.reject(response);
        }
        return response.data;
    },
    error => {
        return Promise.reject(error);
    }
);

export default (
    path,
    options = {
        method: 'GET',
        type: 'json'
    }
) => {
    const opt = cloneDeep(options);
    opt.method = opt.method.toUpperCase();
    if (opt.type === 'formData') {
        const fd = new FormData();
        for (let key in opt.params) {
            if (opt.params[key] instanceof Array) {
                opt.params[key].forEach((item, index) => {
                    fd.append(`${key}[${index}]`, item);
                });
            } else {
                fd.append(key, opt.params[key]);
            }
        }
        opt.params = fd;
    }
    const axiosConfig = {
        url: replaceQuery(path, opt),
        method: opt.method,
        data: opt.params,
        headers: options.headers || {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=UTF-8'
        },
        timeout: 30000
    };
    return axios(axiosConfig);
};
